import React from "react";
import { I18nextProvider } from "react-i18next";

import i18n from "i18n/i18next";
import { LanguageCode, LocalizationStyle } from "types/styles";

interface I18nProviderProps {
  locale?: LanguageCode;
  style?: LocalizationStyle;
}

export const I18nProvider: React.FC<
  React.PropsWithChildren<I18nProviderProps>
> = ({ children, style = "default", locale = "en" }) => {
  React.useEffect(() => {
    async function loadTranslations() {
      await Promise.all([
        i18n.changeLanguage(locale),
        i18n.loadNamespaces(style),
      ]);
      i18n.setDefaultNamespace(style);
    }

    loadTranslations();
  }, [locale, style]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
